// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PBorderHorizontalOutlinedSvg from "@fishx/icons-svg/es/asn/PBorderHorizontalOutlined";
import FishxIcon from '../components/FishxIcon';

var PBorderHorizontalOutlined = function PBorderHorizontalOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PBorderHorizontalOutlinedSvg
  }));
};

PBorderHorizontalOutlined.displayName = 'PBorderHorizontalOutlined';
export default React.forwardRef(PBorderHorizontalOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PBorderHorizontalOutlined.js
// module id = 3243
// module chunks = 0